module.exports = __webpack_public_path__ + "img/unionpay-alternate.e2d63968.png";